import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRobot, FaCode, FaBrain, FaSync, FaHeadset, FaChartLine, FaCloud, FaGlobe, FaMobileAlt } from 'react-icons/fa';
import { FiVideo, FiPhone } from 'react-icons/fi';
import DOSServiceCard from './DOSServiceCard';

const DOS_FONT = "'VT323', 'Courier New', monospace";
const raisedShadow = 'inset -2px -2px 0 #404040, inset 2px 2px 0 #ffffff, inset -1px -1px 0 #808080, inset 1px 1px 0 #dfdfdf';
const pressedShadow = 'inset 2px 2px 0 #404040, inset -1px -1px 0 #ffffff';

const DOSButton = ({ onClick, children }) => {
    const [pressed, setPressed] = React.useState(false);
    const [hovered, setHovered] = React.useState(false);
    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => { setHovered(false); setPressed(false); }}
            onMouseDown={() => setPressed(true)}
            onMouseUp={() => setPressed(false)}
            style={{
                fontFamily: DOS_FONT,
                fontSize: '22px',
                backgroundColor: '#d6fa70',
                color: '#000000',
                boxShadow: pressed ? pressedShadow : hovered ? pressedShadow : raisedShadow,
                border: 'none',
                padding: '6px 32px',
                cursor: 'pointer',
                letterSpacing: '0.05em',
                borderRadius: 0,
                transform: (pressed || hovered) ? 'translate(1px,1px)' : 'none',
            }}
        >
            {children}
        </button>
    );
};

const Services = () => {
    const navigate = useNavigate();
    
    const services = [
        {
            id: 1,
            title: 'AI for Startups',
            icon: <FaRobot />,
            description: 'Full-cycle AI development for startups. From MVP to production, building intelligent solutions that scale.',
            link: '/services/ai-for-startups'
        },
        {
            id: 2,
            title: 'Vibe Coding Cleanup',
            icon: <FaCode />,
            description: 'Transform AI prototypes into production-ready applications with expert code cleanup and optimization.',
            link: '/services/vibe-coding'
        },
        {
            id: 3,
            title: 'AI/ML & Generative AI',
            icon: <FaBrain />,
            description: 'Custom AI copilots, RAG systems, private LLM deployment, and fine-tuning for enterprise needs.',
            link: '/services/ai-ml-generative'
        },
        {
            id: 4,
            title: 'Digital Transformation',
            icon: <FaSync />,
            description: 'Drive innovation and efficiency through tailored digital transformation strategies and modernization.',
            link: '/services/digital-transformation'
        },
        {
            id: 5,
            title: 'Consulting',
            icon: <FaHeadset />,
            description: 'Expert IT consulting services to optimize your technology operations and drive business growth.',
            link: '/services/consulting'
        },
        {
            id: 6,
            title: 'Business Intelligence',
            icon: <FaChartLine />,
            description: 'Transform your data into actionable insights with advanced BI solutions and analytics platforms.',
            link: '/services/business-intelligence'
        },
        {
            id: 7,
            title: 'Cloud Development',
            icon: <FaCloud />,
            description: 'Build scalable cloud-native applications leveraging modern cloud platforms and DevOps practices.',
            link: '/services/cloud-development'
        },
        {
            id: 8,
            title: 'Web Development',
            icon: <FaGlobe />,
            description: 'Responsive, secure, and high-performance web solutions from corporate sites to complex web apps.',
            link: '/services/web-development'
        },
        {
            id: 9,
            title: 'Mobile Development',
            icon: <FaMobileAlt />,
            description: 'Build intuitive mobile apps for iOS and Android that enhance user engagement and deliver experiences.',
            link: '/services/mobile-development'
        },
        {
            id: 10,
            title: 'AI Development',
            icon: <FaBrain />,
            description: 'End-to-end AI solutions with advanced machine learning models and intelligent automation for enterprise.',
            link: '/services/ai-development'
        },
        {
            id: 11,
            title: 'Media Technology',
            icon: <FiVideo />,
            description: 'Innovative media solutions leveraging cutting-edge technology for content creation and distribution.',
            link: '/services/media-technology'
        },
        {
            id: 12,
            title: 'Voice & Telecom',
            icon: <FiPhone />,
            description: 'Advanced voice and telecommunications solutions integrating AI and modern communication platforms.',
            link: '/services/voice-telecom'
        }
    ];

    return (
        <div className='py-20 md:py-36' id="services">
            <div className='container mx-auto'>
                <div className='text-center mb-12'>
                    <h2 className='text-5xl md:text-8xl font-bold mb-4 text-slate-900'>Our Services</h2>
                    <p className='text-xl text-slate-600 max-w-2xl mx-auto'>
                        Comprehensive AI-powered solutions designed to transform your business.
                    </p>
                </div>

                <div className='flex flex-col gap-6 px-4 py-6 md:py-20 md:px-12 rounded-3xl overflow-hidden bg-[#5757FF]'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        {services.map(service => (
                            <DOSServiceCard key={service.id} service={service} />
                        ))}
                    </div>
                    <div className='flex justify-center mt-6'>
                        <DOSButton onClick={() => navigate('/contact')}>
                            ► START YOUR PROJECT
                        </DOSButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;
